import React, { useEffect, useState } from "react"

import { logTool, isIE, css } from "@jsUtils"

// include using svg plugin
import BubbleDots from "@assets/svg/logo-bubbles-distinct.svg"

import Styles from "@pageStyles/index.module.scss"

import { animateIn } from "./bubble.animate"

const log = logTool()

const BubbleWrap = ({ animate }) => {
  const [noAnnie, setAnnie] = useState(false)

  useEffect(() => {
    let timeout
    if (animate) {
      if (isIE()) {
        setAnnie(true)
        return () => {}
      }

      // need to clear this timeout on unload from the return function
      // if you leave the page before GSAP runs, you get console messages
      timeout = setTimeout(() => {
        log("BubbleWrap: useEffect animationIn")
        animateIn(Styles)
      }, 500)
    } else {
      log("setAnnie(true)")
      setAnnie(true)
    }
    return () => {
      log("leaving bubblewrap")
      clearTimeout(timeout)
    }
  }, [])

  return <BubbleDots className={css(noAnnie && Styles.noAnnie)} />
}

export default BubbleWrap
